import "./index.scss";

const Journey1Background = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="595"
    height="176"
    viewBox="0 0 595 176"
    fill="none"
    className="journey-background"
  >
    <path
      d="M3 3.00011C27.5573 3.00011 77.3578 3 151 3.00001L203.562 173L359.203 173L425 173L523.383 173L539.914 173L591.459 173"
      stroke="white"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <path
      d="M3 3.00011C27.5573 3.00011 77.3578 3 151 3.00001L203.562 173L359.203 173L425 173L523.383 173L539.914 173L591.459 173"
      stroke="url(#paint0_linear_6602_14886)"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6602_14886"
        x1="104.944"
        y1="2.55075"
        x2="740.662"
        y2="2.55078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00EBC8" />
        <stop offset="0.0223025" stopColor="#00EBC8" />
        <stop offset="0.774073" stopColor="#DD00FF" />
      </linearGradient>
    </defs>
  </svg>
);

const Journey2Background = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="595"
    height="176"
    viewBox="0 0 595 176"
    fill="none"
    className="journey-background"
  >
    <path
      d="M2.99999 173C27.5573 173 77.3578 173 151 173L203.562 3.00001L383.202 3.00002L435 173L523.383 173L539.914 173L591.459 173"
      stroke="white"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <path
      d="M2.99999 173C27.5573 173 77.3578 173 151 173L203.562 3.00001L383.202 3.00002L435 173L523.383 173L539.914 173L591.459 173"
      stroke="url(#paint0_linear_6602_7879)"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6602_7879"
        x1="104.944"
        y1="2.55079"
        x2="740.662"
        y2="2.55082"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00EBC8" />
        <stop offset="0.024015" stopColor="#00EBC8" />
        <stop offset="0.763799" stopColor="#DD00FF" />
      </linearGradient>
    </defs>
  </svg>
);

const Journey3Background = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="595"
    height="176"
    viewBox="0 0 595 176"
    fill="none"
    className="journey-background"
  >
    <path
      d="M2.99999 173C27.5573 173 77.3578 173 151 173L203.562 173L383.202 173L435 3.00002L479.191 3.00013L523.383 3.00013L539.914 3.00002L591.459 3.00018"
      stroke="white"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <path
      d="M2.99999 173C27.5573 173 77.3578 173 151 173L203.562 173L383.202 173L435 3.00002L479.191 3.00013L523.383 3.00013L539.914 3.00002L591.459 3.00018"
      stroke="url(#paint0_linear_6602_12486)"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6602_12486"
        x1="104.944"
        y1="2.55083"
        x2="740.662"
        y2="2.55086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00EBC8" />
        <stop offset="0.024015" stopColor="#00EBC8" />
        <stop offset="0.763799" stopColor="#DD00FF" />
      </linearGradient>
    </defs>
  </svg>
);

type JourneyItem = {
  id: string;
  label: string;
};

export type Journey = {
  id: string;
  title: string;
  items: JourneyItem[];
};

type Props = {
  onJourneyClicked: (tabId: string, subItemId?: string) => void;
  journey1: Journey;
  journey2: Journey;
  journey3: Journey;
  activeJourneyId?: string;
  activeJourneyItemId?: string;
};

export const SolutionJourneyTabs = ({
  onJourneyClicked,
  journey1,
  journey2,
  journey3,
  activeJourneyId,
  activeJourneyItemId,
}: Props) => {
  const handleJourneyClick = (journey: Journey) => {
    onJourneyClicked(journey.id, undefined);
  };

  const handleItemClick = (
    itemId: string,
    journeyId: string,
    event: React.MouseEvent
  ) => {
    event.stopPropagation();
    onJourneyClicked(journeyId, itemId);
  };

  const renderJourney = (journey: Journey) => {
    const isSelected = activeJourneyId === journey.id;

    return (
      <div
        className={`journey-item ${isSelected ? "active" : ""}`}
        key={journey.id}
        onClick={() => handleJourneyClick(journey)}
      >
        <div className="title">{journey.title}</div>
        <div className="text">
          {journey.items.map(item => (
            <div
              key={item.id}
              className={`text-row ${
                activeJourneyItemId === item.id ? "selected" : ""
              }`}
              onClick={e => handleItemClick(item.id, journey.id, e)}
              title={item.label}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="solution-journey-tabs">
      {activeJourneyId === journey1.id && <Journey1Background />}
      {activeJourneyId === journey2.id && <Journey2Background />}
      {activeJourneyId === journey3.id && <Journey3Background />}

      <div className="journey-items">
        {renderJourney(journey1)}
        {renderJourney(journey2)}
        {renderJourney(journey3)}
      </div>
    </div>
  );
};
